import React, { useEffect, useState } from 'react'
import './Customer.css'
import Header from '../components/Header'
import axios from 'axios'
import { Link } from 'react-router-dom'

const getAuthToken = () =>
  document.cookie.replace(/(?:(?:^|.*;\s*)auth\s*=\s*([^;]*).*$)|^.*$/, "$1")

const BOOKING_COLORS = {
  daily: { bg: 'rgba(239,68,68,0.15)', color: '#f87171', label: '1 Day' },
  monthly: { bg: 'rgba(59,130,246,0.15)', color: '#60a5fa', label: '1 Month' },
  quarterly: { bg: 'rgba(251,146,60,0.15)', color: '#fb923c', label: '3 Months' },
  halfyearly: { bg: 'rgba(168,85,247,0.15)', color: '#c084fc', label: '6 Months' },
  yearly: { bg: 'rgba(16,185,129,0.15)', color: '#34d399', label: '12 Months' },
}

const Customers = () => {
  const [bookings, setBookings] = useState([])
  const [filteredBookings, setFilteredBookings] = useState([])
  const [selectedDate, setSelectedDate] = useState('')
  const [selectedSlotTime, setSelectedSlotTime] = useState('all')
  const [searchTerm, setSearchTerm] = useState('')
  const [loading, setLoading] = useState(true)

  const getAllBooking = async () => {
    setLoading(true)
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/customers`, {
        headers: { auth: getAuthToken() },
      })
      const data = response.data.UniqueCustomers || []
      setBookings(data)
      setFilteredBookings(data)
    } catch (error) {
      console.error('Error fetching bookings:', error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => { getAllBooking() }, [])

  useEffect(() => {
    let filtered = bookings
    if (selectedDate) filtered = filtered.filter(b => b.bookingDate === selectedDate)
    if (selectedSlotTime !== 'all') filtered = filtered.filter(b => b.slotStartTime === selectedSlotTime)
    if (searchTerm) {
      const q = searchTerm.toLowerCase()
      filtered = filtered.filter(b =>
        b.userFullName.toLowerCase().includes(q) || b.userMobileNumber.includes(searchTerm)
      )
    }
    setFilteredBookings(filtered)
  }, [selectedDate, selectedSlotTime, searchTerm, bookings])

  const uniqueSlotTimes = [...new Set(bookings.map(b => b.slotStartTime))]

  const getType = (type) => BOOKING_COLORS[type?.toLowerCase()] || { bg: 'rgba(100,116,139,0.15)', color: '#94a3b8', label: type }

  return (
    <div className="customers-page">
      <Header />
      <div className="cust-content">
        <div className="cust-page-header">
          <div>
            <h1 className="cust-page-title">Customers</h1>
            <p className="cust-page-sub">{bookings.length} total members</p>
          </div>
          <button className="cust-btn-refresh" onClick={getAllBooking}>↻ Refresh</button>
        </div>

        <div className="cust-filters">
          <div className="cust-filter-group">
            <label>Booking Date</label>
            <input
              type="date"
              value={selectedDate}
              onChange={e => setSelectedDate(e.target.value)}
            />
          </div>
          <div className="cust-filter-group">
            <label>Slot Time</label>
            <select value={selectedSlotTime} onChange={e => setSelectedSlotTime(e.target.value)}>
              <option value="all">All Slots</option>
              {uniqueSlotTimes.map((t, i) => <option key={i} value={t}>{t}</option>)}
            </select>
          </div>
          <div className="cust-filter-group cust-filter-search">
            <label>Search</label>
            <input
              type="text"
              placeholder="Name or mobile number..."
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className="cust-table-card">
          {loading ? (
            <div className="cust-empty">
              <div className="cust-spinner" />
              <p>Loading customers...</p>
            </div>
          ) : filteredBookings.length === 0 ? (
            <div className="cust-empty">
              <div className="cust-empty-icon">👥</div>
              <p>No customers found for selected filters.</p>
            </div>
          ) : (
            <div className="cust-table-wrap">
              <table className="cust-table">
                <thead>
                  <tr>
                    <th>Booking ID</th>
                    <th>Customer</th>
                    <th>Mobile</th>
                    <th>Booking Date</th>
                    <th>Slot</th>
                    <th>Price</th>
                    <th>Type</th>
                    <th>Rating</th>
                    <th>Payment</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredBookings.map((booking, index) => {
                    const typeInfo = getType(booking.bookingType)
                    return (
                      <tr key={index}>
                        <td className="cust-id">#{booking.bookingId}</td>
                        <td>
                          <Link className="cust-link" to={`/bookings?name=${encodeURIComponent(booking.userFullName)}`}>
                            {booking.userFullName}
                          </Link>
                        </td>
                        <td>
                          <Link className="cust-link" to={`/bookings?name=${encodeURIComponent(booking.userMobileNumber)}`}>
                            {booking.userMobileNumber}
                          </Link>
                        </td>
                        <td>{new Date(booking.bookingDate).toLocaleDateString()}</td>
                        <td>{booking.slotStartTime}</td>
                        <td className="cust-price">₹{booking.subscriptionPrice}</td>
                        <td>
                          <span className="cust-type-badge" style={{ background: typeInfo.bg, color: typeInfo.color }}>
                            {typeInfo.label}
                          </span>
                        </td>
                        <td>
                          {booking.gymRating ? (
                            <span className="cust-rating">⭐ {booking.gymRating}</span>
                          ) : '—'}
                        </td>
                        <td>
                          <span className={`cust-payment-badge ${booking.isPaid ? 'paid' : 'unpaid'}`}>
                            {booking.isPaid ? 'Paid' : 'Unpaid'}
                          </span>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>

        <p className="cust-count-footer">
          Showing {filteredBookings.length} of {bookings.length} customers
        </p>
      </div>
    </div>
  )
}

export default Customers
